<template>
  <v-snackbar
    :model-value="show"
    @update:model-value="$emit('update:show', $event)"
    :timeout="timeout"
    :color="color"
    :location="location"
    :rounded=true
    class="mb-16"
    vertical
  >
    <slot>
      {{ message }}
    </slot>
  </v-snackbar>
</template>

<script>
export default {
  name: "MessageSnackbar",
  props: {
    message: {
      type: String,
    },
    color: {
      type: String,
      default: "info", // Default color if none is provided
    },
    timeout: {
      type: Number,
    },
    location: {
      type: String,
      default: "bottom", // Default location for the snackbar
    },
    show: {
      type: Boolean,
      required: true, // Snackbar visibility controlled by the parent
    },
    closeButton: {
      type: Boolean,
      default: false, // Default to false unless explicitly set
    },
    rounded: {
      type: [Boolean, String],
      default: "shaped",
    },
  },
  emits: ["update:show"], // Allows two-way binding for the `show` prop
};
</script>
